import { FC, useCallback } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EditIcon from '@mui/icons-material/Edit';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import RoomRatesTableDateRow from 'components/RoomRatesTableDateRow';
import RoomRatesTableHead from 'components/RoomRatesTableHead';

import { useTabber } from 'components/Tabber';

import { RoomRatesTable_package$key } from '__generated__/RoomRatesTable_package.graphql';
import { RoomRatesTable_data$key } from '__generated__/RoomRatesTable_data.graphql';

type Props = {
  data: RoomRatesTable_data$key;
  package: RoomRatesTable_package$key;
};

const RoomRatesTable: FC<Props> = props => {
  const { changeTab } = useTabber();

  const data = useFragment(
    graphql`
      fragment RoomRatesTable_data on Query {
        ...RoomRatesTableDateRow_data
      }
    `,
    props.data
  );

  const pack = useFragment(
    graphql`
      fragment RoomRatesTable_package on Package {
        groupedRates {
          date {
            id
          }

          ...RoomRatesTableDateRow_groupedRate
        }

        ...RoomRatesTableHead_package
        ...RoomRatesTableDateRow_package
      }
    `,
    props.package
  );

  const handleEditDatesClick = useCallback(() => {
    changeTab('dates');
  }, [changeTab]);

  const { groupedRates } = pack;

  if (groupedRates.length < 1) {
    return (
      <Alert
        severity="warning"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={handleEditDatesClick}
            startIcon={<EditIcon />}>
            Redaguoti datas
          </Button>
        }>
        Šis pasiūlymas dar neturi kelionės datų
      </Alert>
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <RoomRatesTableHead package={pack} />
        </TableHead>

        <TableBody>
          {groupedRates.map(groupedRate => (
            <RoomRatesTableDateRow
              key={groupedRate.date.id}
              data={data}
              groupedRate={groupedRate}
              package={pack}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RoomRatesTable;
